// @flow

import React from 'react'
import type { Node, Element } from 'react'

type InputLabelSubtitleProps = {
  children: Node,
}

export function InputLabelSubtitle({
  children,
}: InputLabelSubtitleProps): Element<'span'> {
  return (
    <span
      className="text-purple-lightest text-xs"
      style={{ position: 'relative', top: '-2px' }}
    >
      {children}
    </span>
  )
}

export default InputLabelSubtitle
